module.exports = __webpack_public_path__ + "29d413eef397c2b4c51e456804da15ba.png";